import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

// eslint-disable-next-line import/no-default-export
export default Loadable({
  loading: LoadingPage,
  loader: () => import(/* webpackChunkName: "create-branch" */ './page'),
});
